var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sc-message-list"},[_vm._l((_vm.messages),function(message){return [_c('Message',{key:message,attrs:{"message":message}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }